/**
 * Org marketplace -> Fees and payouts (docs/Decisions.md D72): the
 * organization's share of each lead fee (the organization fee less the
 * platform fee), whether it has been paid out, and the organization's payout
 * account with Stripe.
 */
import { useEffect, useState } from 'react';
import * as marketApi from '../api/marketplace';
import FeeTable from './FeeTable';
import PayoutAccountCard from './PayoutAccountCard';
import { Spinner, ErrorAlert } from './ui';
import { formatUsd } from '../lib/marketplace';
import { cn, ui } from '../lib/ui';

export default function OrgFeesPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    marketApi.listOrgFees().then(setData).catch(setError);
  }, []);

  if (error) return <ErrorAlert error={error} />;
  if (!data) return <Spinner label="Loading fees..." />;
  return (
    <section>
      <PayoutAccountCard kind="org" title="The organization's payouts">
        <p className={cn(ui.hint, 'mt-0')}>
          The organization&apos;s share of each lead fee is paid out once the vendor pays its
          invoice.
        </p>
      </PayoutAccountCard>
      <dl className="mb-4 grid grid-cols-2 gap-3 md:grid-cols-3">
        {[
          ['Organization share', data.totals.orgShareCents],
          ['Platform fees', data.totals.platformFeeCents],
          ['Vendors paid in total', data.totals.vendorPaysCents],
        ].map(([label, cents]) => (
          <div key={label} className={ui.cardFlat}>
            <dt className={ui.hint}>{label}</dt>
            <dd className="m-0 text-title-m">{formatUsd(cents)}</dd>
          </div>
        ))}
      </dl>
      <FeeTable fees={data.fees} label="Marketplace fees" show="org" />
    </section>
  );
}
